import { camelizeKeys, decamelize, decamelizeKeys } from "humps";
import {
  RHEA_CMS_REPORTS_API_ENDPOINT,
  RHEA_CMS_REPORT_API_ENDPOINT,
} from "../Constants/API";
import getCustomAxios from "../Helpers/customAxios";
import { getAccessTokenFromLocalStorage } from "../Helpers/jwtUtility";

export function getReportListAPI(
  filtersMap = new Map(),
  onSuccessCallback,
  onErrorCallback,
  onDoneCallback
) {
  const axios = getCustomAxios();

  // The following code will generate the query parameters for the url based on the map.
  let aURL = RHEA_CMS_REPORTS_API_ENDPOINT;
  filtersMap.forEach((value, key) => {
    let decamelizedkey = decamelize(key);
    if (aURL.indexOf("?") > -1) {
      aURL += "&" + decamelizedkey + "=" + value;
    } else {
      aURL += "?" + decamelizedkey + "=" + value;
    }
  });

  axios
    .get(aURL)
    .then((successResponse) => {
      const responseData = successResponse.data;

      // Snake-case from API to camel-case for React.
      const data = camelizeKeys(responseData);

      // Return the callback data.
      onSuccessCallback(data);
    })
    .catch((exception) => {
      let errors = camelizeKeys(exception);
      onErrorCallback(errors);
    })
    .then(onDoneCallback);
}

export function postReportCreateAPI(
  data,
  onSuccessCallback,
  onErrorCallback,
  onDoneCallback
) {
  const axios = getCustomAxios();

  // Minor formatting to support API.
  data.userId = data.userID;
  data.no = parseInt(data.no);
  data.duration = parseInt(data.duration);
  data.targetHeartRate = parseFloat(data.targetHeartRate);
  data.targetHeartRateRatio = parseFloat(data.targetHeartRateRatio);

  // To Snake-case for API from camel-case in React.
  let decamelizedData = decamelizeKeys(data);

  axios
    .post(RHEA_CMS_REPORTS_API_ENDPOINT, decamelizedData)
    .then((successResponse) => {
      const responseData = successResponse.data;

      // Snake-case from API to camel-case for React.
      const data = camelizeKeys(responseData);

      // Minor formatting to support API.
      data.userID = data.userId;

      // Return the callback data.
      onSuccessCallback(data);
    })
    .catch((exception) => {
      let errors = camelizeKeys(exception);
      onErrorCallback(errors);
    })
    .then(onDoneCallback);
}

export function getReportDetailAPI(sessionTemplateID) {
  const axios = getCustomAxios();
  const accessToken = getAccessTokenFromLocalStorage();

  return axios
    .get(RHEA_CMS_REPORT_API_ENDPOINT.replace("{id}", sessionTemplateID), {
      responseType: "arraybuffer",
      headers: {
        Accept: "application/pdf",
        Authorization: accessToken,
      },
    })
    .then((successResponse) => successResponse)
    .catch((exception) => {
      let errors = camelizeKeys(exception);
      throw errors;
    });
}

export function putReportUpdateAPI(
  data,
  onSuccessCallback,
  onErrorCallback,
  onDoneCallback
) {
  const axios = getCustomAxios();

  // Minor formatting to support API.
  data.userId = data.userID;
  data.no = parseInt(data.no);
  data.duration = parseInt(data.duration);
  data.targetHeartRate = parseFloat(data.targetHeartRate);
  data.targetHeartRateRatio = parseFloat(data.targetHeartRateRatio);

  // To Snake-case for API from camel-case in React.
  let decamelizedData = decamelizeKeys(data);

  axios
    .put(
      RHEA_CMS_REPORT_API_ENDPOINT.replace("{id}", decamelizedData.id),
      decamelizedData
    )
    .then((successResponse) => {
      const responseData = successResponse.data;

      // Snake-case from API to camel-case for React.
      const data = camelizeKeys(responseData);

      // Minor formatting to support API.
      data.userID = data.userId;

      // Return the callback data.
      onSuccessCallback(data);
    })
    .catch((exception) => {
      let errors = camelizeKeys(exception);
      onErrorCallback(errors);
    })
    .then(onDoneCallback);
}

export function deleteReportAPI(
  id,
  onSuccessCallback,
  onErrorCallback,
  onDoneCallback
) {
  const axios = getCustomAxios();
  axios
    .delete(RHEA_CMS_REPORT_API_ENDPOINT.replace("{id}", id))
    .then((successResponse) => {
      const responseData = successResponse.data;

      // Snake-case from API to camel-case for React.
      const data = camelizeKeys(responseData);

      // Return the callback data.
      onSuccessCallback(data);
    })
    .catch((exception) => {
      let errors = camelizeKeys(exception);
      onErrorCallback(errors);
    })
    .then(onDoneCallback);
}
